/**
 * Created by sange on 15/08/2017.
 */

import { createEntityAdapter, EntityState } from '@ngrx/entity'
import { VendorTeamV1 } from '../../../../api/api/models/vendor-team-v1'

import * as teamActions from '../actions/team.actions'

export interface VendorTeamExtended extends VendorTeamV1 {
  newMessage: boolean
}

export interface State extends EntityState<VendorTeamExtended> {
  editingTeamId: number
}

export const adapter = createEntityAdapter<VendorTeamExtended>({
  selectId: (team: VendorTeamExtended) => team.id,
  sortComparer: false
})

export const initialState: State = adapter.getInitialState({
  editingTeamId: -1,
})

export function reducer(state = initialState, action: any): State {
  switch (action.type) {

    case teamActions.LOAD_TEAMS_SUCCESS: {
      return adapter.addMany(action.payload.teams, state)
    }

    case teamActions.LOAD_TEAM_SUCCESS: {
      return adapter.addOne(action.payload.team, state)
    }

    case teamActions.CREATE_TEAM_SUCCESS: {
      return adapter.addOne(action.payload.team, state)
    }

    case teamActions.UPDATE_TEAM_SUCCESS: {
      const {team} = action.payload
      return adapter.updateOne({id: team.id, changes: {...team}}, state)
    }

    case teamActions.UPLOAD_TEAM_IMAGE_SUCCESS: {
      const {imgUrl, vendorTeamId} = action.payload
      return adapter.updateOne({id: vendorTeamId, changes: {imgUrl}}, state)
    }

    case teamActions.UPLOAD_TEAM_LOGO_SUCCESS: {
      const {logoImgUrl, vendorTeamId} = action.payload
      return adapter.updateOne({id: vendorTeamId, changes: {logoImgUrl}}, state)
    }

    case teamActions.SELECT_TEAM_FOR_EDITING_DONE: {
      const {selectingTeamId} = action.payload
      if (state.editingTeamId === selectingTeamId) {
        return state
      }
      const newState = {...state, editingTeamId: selectingTeamId} as State

      return {
        ...newState,
      } as State
    }

    case teamActions.REMOVE_TEAM: {
      return adapter.removeOne(action.payload.vendorTeamId, state)
    }

    case teamActions.TEAM_UPDATED_EVENT_FINISH: {
      const {teamId, teamName, hasCallMeEnabled, motto} = action.payload
      return adapter.updateOne({id: teamId, changes: { name: teamName, hasCallMeEnabled: hasCallMeEnabled, motto: motto }}, state)
    }

    default: {
      return state
    }
  }
}

export const getEditingTeamId = (state: State) => state.editingTeamId






// WEBPACK FOOTER //
// ./src/app/shared/team/store/reducers/team.reducer.ts